import navigationBarStyles from "../../styles/dashboard-navigation-bar.css.js";

export default theme => ({
  ...navigationBarStyles(theme),

  navigationBar: {
    display: "flex",
    justifyContent: "space-between",
    margin: 3,
  },
});
